import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./SportsAndTourism.css";
import Heading from "../../../utls/Heading";
const SportsAndTourism = () => {
  return (
    <>
      <div className="container sports-and-tourism">
        <div className="row px-lg-4">
          <div className="col-md-12">
            <Heading className="headings ">
              <span>Sports</span> and Tourism
            </Heading>
            <p className="sports-p1">
              Sports and Tourism are crucial to the growth and economic
              development of travel destinations. Together, they significantly
              affect the socio-economic sector of the societies.
            </p>
            <p className="mid-head-p grotesk-headings">
              Why Blueberry Travel for Your Next Sports Adventure?
            </p>
            <p className="sports-p2">
              <b>Expert Knowledge:</b> Our team of passionate travel experts is
              deeply knowledgeable about both domestic and international sports
              events and destinations. We design customized itineraries adapted
              to your interests, budget, and activity level, ensuring a perfect
              match for your travel preference.
              <br />
              <br />
              <b>Smooth Coordination:</b>
              We manage all logistics, from flights and accommodations to ground
              transportation and event reservations. Hence, ensuring a flawless
              and enjoyable travel experience for our corporate travelers.
              <br />
              <br />
              <b>Exclusive Experiences:</b>
              Enjoy VIP perks such as behind-the-scenes tours, athlete
              meet-and-greets, and special access to pre-sport activities,
              making your trip truly unforgettable.
              <br />
              <br />
              <b>Dedicated Service:</b>
              We are strongly dedicated to delivering exceptional service at
              every step of your journey, exceeding your expectations, and
              creating memories that last a lifetime.
            </p>

            {/* .........................................side crads........................................... */}

            <div className="safetyCardBox mt-5 pt-lg-5 mb-5 pb-lg-4">
              <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
                <Heading className="headings mt-3  ps-md-0">
                  <span>Group</span> Travel
                </Heading>
                <p className="sportsP-one grotesk-headings">
                  At Blueberry Travel, we specialize in creating memorable group
                  travel experiences. Whether it’s a corporate retreat, a family
                  reunion, or a large group of friends, we handle all the
                  details so you can focus on enjoying the journey together and
                  bringing back good memories.
                </p>
                <p className="sportsP-two grotesk-headings">
                  <h5 className="fw-bold">Key Features:</h5>
                  <ul>
                    <li>Customized travel itineraries</li>
                    <li>
                      Dedicated travel manager support to assist with every step
                    </li>
                    <li>
                      Exclusive discounts on flights, accommodations, and
                      activities on group bookings
                    </li>
                    <li>
                      Round-the-clock assistance from our experienced travel
                      team
                    </li>
                    <li>Individualized catering and private dining</li>
                    <li>
                      Assistance from the language experts in case of
                      understanding local language
                    </li>
                    <li>Private train and air facility for group travelers</li>
                  </ul>
                </p>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-5">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/sports1.png"
                  alt=""
                  className="safetyTravelimg mission-images"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="safetyCardBoxReverse mb-5 pb-lg-5">
              <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
                <Heading className="headings mt-3  ps-md-0">
                  <span>Sports</span> Concierge Tour{" "}
                </Heading>
                <p className="sportsP-one">
                  Are you a high-profile sports professional seeking a concierge
                  service? At BBT, we specialize in providing customized
                  services for athletes and sports professionals on business
                  trips. Our global expertise allow us to forecast and exceed
                  the expectations of our high-profile clients.
                </p>
                <p className="sportsP-two">
                  <h5 className="fw-bold">Key Features:</h5>
                  <ul>
                    <li>Car Transfers</li>
                    <li>Private Charter Flights</li>
                    <li>Airport Assistance</li>
                    <li>Full Concierge Service</li>
                    <li>High Level of Discretion</li>
                    <li>Private Security Clearance</li>
                    <li>Meet and Greet</li>
                  </ul>
                </p>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-4">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/sports2.png"
                  alt=""
                  className="safetyTravelimg safetyTravelimg2 mission-images"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="safetyCardBox mb-5 pb-lg-5">
              <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-5">
                <Heading className="headings mt-3  ps-md-0">
                  <span>Sports</span> Travel Technology
                </Heading>
                <p className="sportsP-one">
                  At Blueberry Travel, we take the stress out of sports travel
                  by offering automatic mobile booking tools, group logistics
                  management, real-time passenger tracking, and detailed
                  reporting. With us, you can focus on your game while we handle
                  the rest.
                </p>
                <p className="sportsP-two">
                  Our clients benefit from our award-winning, patented travel
                  management solutions, ensuring a smooth, trouble-free travel
                  experience before, during, and after every trip. Whether
                  you’re a solo traveler or managing an entire team, our
                  all-in-one travel portal gives you the control, convenience,
                  and confidence to make every journey memorable.
                </p>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/sports3.png"
                  alt=""
                  className="safetyTravelimg mission-images"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="safetyCardBoxReverse mb-5 pb-lg-5s">
              <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3 third-sports">
                <Heading className="headings ps-md-0">
                  <span>Sustainability</span> in Sports Travel{" "}
                </Heading>
                <p className="sportsP-one">
                  We acknowledge that the sports sector is spearheading the
                  battle against climate change, and we have several programs to
                  back up your plan. At Blueberry Travel, sustainability isn’t
                  just an add-on service; it is an integral part of our products
                  and systems, ensuring that eco-friendly solutions are part of
                  every journey.
                </p>
                <p className="sportsP-two">
                  Our commitment to sustainability is visible in our dynamic
                  webinars and interactive seminars, which allow sports
                  organizations to integrate green practices into their
                  operations. By embracing sustainable travel strategies, we are
                  proud to reduce the environmental impact of sports travel,
                  contributing to a healthier planet. Together, we can stand up
                  for a greener future for the sports industry and the world.
                </p>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-5">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/sports5.png"
                  alt=""
                  className="safetyTravelimg safetyTravelimg2 mission-images"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="safetyCardBox ct-lastcard-mb mb-5 pb-lg-5">
              <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
                <Heading className="headings mt-3   ps-md-0">
                  <span>Risk </span> Management and Reporting Tool
                </Heading>
                <p className="sportsP-one">
                  Our innovative tracking tool guarantees effortless
                  communication and safety for your team. With real-time
                  itinerary updates and instant SMS and email alerts for delays
                  or missed communication, you’ll always have peace of mind.
                  Meanwhile, our mobile-friendly pre-trip approval system
                  simplifies budget and safety management, allowing travelers to
                  request booking permissions with ease.
                </p>
                <p className="sportsP-two">
                  Our global risk assessment platform keeps you informed of
                  potential dangers before and during travel by sending
                  emergency alerts when needed. Our advanced reporting software
                  provides a detailed snapshot of your travel budget, covering
                  everything from accommodation and airfare to ground transport
                  and any extra charges.
                </p>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/sports4.png"
                  alt=""
                  className="safetyTravelimg mission-images"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SportsAndTourism;
